<template>
  <div>
    <div class="ih-header date-container-blur">
      <div class="ih-container">
        <div class="ih-tabs-wrapper">
          <div class="ih-tabs-container" ref="tabsContainer">
            <div class="ih-tab-inner" ref="allSportsLink" @click="goHome">
                <span
                    ref="allSportsText"
                    class="ih-tab-text"
                    :class="{ 'ih-text-active': !isLivePage, 'ih-text-muted': isLivePage }"
                >
                  {{ $t('allsports') }}
                </span>
            </div>

            <div class="ih-tab-inner" ref="liveLink" @click="goLive" v-if="getSettings.enableLive">
                <span
                    class="ih-tab-text"
                    :class="{ 'ih-text-active': isLivePage, 'ih-text-muted': !isLivePage }"
                >
                  {{ $t('live') }}
                </span>
            </div>

            <div
                class="ih-indicator"
                :style="{
                width: barWidthPx + 'px',
                transform: 'translateX(' + barLeftPx + 'px)'
              }"
            ></div>

          </div>
        </div>

        <div class="ih-settings-wrapper">
          <div class="ih-dropdown-container" ref="dropdownContainer">
            <button
                @click="toggleOddsTypeDropdown"
                aria-label="Odds Type Settings"
                class="ih-settings-btn"
            >
              <div class="ih-icon-box">
                <IllinoisIcons icon="settings" style="width: 20px; height: 20px" :width="20" :height="20" />
              </div>
            </button>

            <transition name="ih-fade">
              <div
                  v-if="showOddsTypeDropdown"
                  ref="dropdownContent"
                  class="ih-dropdown-menu"
                  :style="dropdownStyle"
              >
                <div class="ih-dropdown-padding">
                  <div class="ih-dropdown-title">
                    {{ $t('oddsType') }}
                  </div>
                  <div class="ih-dropdown-options">
                    <label
                        class="ih-radio-label"
                        :class="{ 'ih-bg-hover': currentOddsType === 'decimal' }"
                    >
                      <input
                          type="radio"
                          name="oddsType"
                          value="decimal"
                          :checked="currentOddsType === 'decimal'"
                          @change="handleOddsTypeChange('decimal')"
                          class="ih-radio-input"
                      />
                      <span class="ih-radio-text">{{ $t('decimal') }}</span>
                    </label>
                    <label
                        class="ih-radio-label"
                        :class="{ 'ih-bg-hover': currentOddsType === 'american' }"
                    >
                      <input
                          type="radio"
                          name="oddsType"
                          value="american"
                          :checked="currentOddsType === 'american'"
                          @change="handleOddsTypeChange('american')"
                          class="ih-radio-input"
                      />
                      <span class="ih-radio-text">{{ $t('american') }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IllinoisIcons from './icons.vue';
import {mapActions, mapGetters} from "vuex";
const PAGES = {
  PREMATCH_PREVIEW: 'prematch_preview',
  PREMATCH_DETAIL:  'prematch_detail',
  LIVE_LIST:        'live_list',
  LIVE_DETAIL:      'live_detail',
  RESULT:           'result',
  QBET:             'qBet',
  PRINT_ODDS:       'printodds',
  EVENTS_DAY:       'list_events_day',
}

export default {
  name: 'IllinoisHeader',
  components: {
    IllinoisIcons
  },
  data() {
    return {
      barWidthPx: 0,
      barLeftPx: 0,
      showOddsTypeDropdown: false,
      dropdownStyle: {}
    };
  },
  computed: {
    ...mapGetters('topsports', [
      'getSortedSports',
      'getOpenSportId',
      'getActiveSportId',
      'getCategoriesBySport',
    ]),
    ...mapGetters('ui', ['getSubaction']),

    ...mapGetters({
      'getEventsDetail': 'detailPrematch/getEventsDetail',
      'getEventsLiveDetail': 'odds/getEventsLiveDetail',
      'getViewMode': 'ui/getViewMode',
      'getBet':                    'cart/getBet',
      'getTournamentsActive':      'previewPrematch/getTournamentsActive',
      'getEventsLiveDetailActive': 'detailLive/getEventsLiveDetailActive',
      'getSettings':               'cart/getSettings',
    }),
    currentPage() {
      if (this.getEventsLiveDetail.length > 0)  return PAGES.LIVE_DETAIL
      if (this.getEventsDetail.length > 0 || (this.getEventsDetailActive && this.getEventsDetailActive.length > 0)) return PAGES.PREMATCH_DETAIL
      if (this.getViewMode === 'detail')          return PAGES.LIVE_LIST
      if (this.getViewMode === 'preview')         return PAGES.PREMATCH_PREVIEW
      // Utility modes pass through verbatim (result, qBet, printodds, list_events_day)
      return this.getViewMode
    },
    isLivePage() {
      return this.currentPage === PAGES.LIVE_LIST || this.currentPage === PAGES.LIVE_DETAIL
    },
    currentOddsType() {
      return this.$store.getters['odds/getOddsType'] || 'decimal';
    }
  },
  async mounted() {
    await this.$nextTick();
    this.updateBarWidth();
    window.addEventListener('resize', this.updateBarWidth, { passive: true });
    document.addEventListener('click', this.handleClickOutside);
    this.$watch(
        () => this.$route.path,
        async () => {
          await this.$nextTick();
          this.updateBarWidth();
        }
    );
    this.$watch(
        () => this.isLivePage,
        async () => {
          await this.$nextTick();
          this.updateBarWidth();
        }
    );
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateBarWidth);
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    ...mapActions('topsports', [
      'fetchSportsNavigation',
      'toggleSport',
    ]),
    ...mapActions('ui', ['setSubaction']),
    ...mapActions({
      'removeFromDetail': 'detailPrematch/removeFromDetail',
      'removeFromPreview': 'previewPrematch/removeFromPreview',
      'removeEventLiveDetail': 'detailLive/removeEventLiveDetail',
      'setViewMode': 'ui/setViewMode',
      'setSubaction':          'ui/setSubaction',
      'resetPreviewLive':      'previewLive/resetPreviewLive',
      'setActiveTournamentIdLivePreview': 'marketview/setActiveTournamentIdLivePreview',
    }),
    goHome() {
      const detailSources = (this.getEventsDetail || []).map(e => e.source).filter(Boolean);
      detailSources.forEach(source => this.removeFromDetail({ source }));

      const previewSources = [...(this.getTournamentsActive || [])];
      previewSources.forEach(source => this.removeFromPreview({ source }));

      const liveSources = [...(this.getEventsLiveDetailActive || [])];
      liveSources.forEach(source => this.removeEventLiveDetail(source));

      // Live-scoped: left set, it kept the prematch home filtered by the live
      // tree's tournament, and kept filtering after a sport change too.
      this.setActiveTournamentIdLivePreview([]);
      this.resetPreviewLive();
      this.setViewMode({ mode: 'preview' });
      this.setSubaction('home');
      window.parent.postMessage({ type: 'removeSlugs' }, '*');
      window.scrollTo({ top: 0, behavior: 'smooth' });

    },
    goLive() {
      // Close all open prematch details
      const detailSources = (this.getEventsDetail || []).map(e => e.source).filter(Boolean);
      detailSources.forEach(source => this.removeFromDetail({ source }));

      // Close all open prematch previews
      const previewSources = [...(this.getTournamentsActive || [])];
      previewSources.forEach(source => this.removeFromPreview({ source }));

      // Close all open live details
      const liveSources = [...(this.getEventsLiveDetailActive || [])];
      liveSources.forEach(source => this.removeEventLiveDetail(source));

      // Go to live section
      this.setViewMode({ mode: 'detail', section: 'live' });
      window.parent.postMessage({ type: 'liveSectionEntered' }, '*');

      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    updateBarWidth() {
      const sportRef = this.$refs.allSportsLink;
      const liveRef = this.$refs.liveLink;
      const containerRef = this.$refs.tabsContainer;
      const sportTextRef = this.$refs.allSportsText;

      const sportEl = sportRef ? (sportRef.$el || sportRef) : null;
      const liveEl = liveRef ? (liveRef.$el || liveRef) : null;
      const containerEl = containerRef ? (containerRef.$el || containerRef) : null;
      const sportTextEl = sportTextRef ? (sportTextRef.$el || sportTextRef) : null;

      // liveEl is optional — when live is disabled at the platform level the tab is not rendered,
      // and the indicator still needs to underline the "All sports" tab.
      if (!sportEl || (this.isLivePage && !liveEl)) {
        this.barWidthPx = 0;
        return;
      }

      const targetEl = this.isLivePage ? liveEl : (sportTextEl || sportEl);

      if (containerEl && targetEl) {
        const cRect = containerEl.getBoundingClientRect();
        const tRect = targetEl.getBoundingClientRect();
        this.barLeftPx = tRect.left - cRect.left;
      } else {
        this.barLeftPx = 0;
      }

      this.barWidthPx = this.isLivePage
          ? targetEl.offsetWidth
          : (sportTextEl ? sportTextEl.offsetWidth : (sportEl.offsetWidth || 0));
    },
    toggleOddsTypeDropdown() {
      this.showOddsTypeDropdown = !this.showOddsTypeDropdown;
      if (this.showOddsTypeDropdown) {
        this.$nextTick(() => {
          this.calculateDropdownPosition();
        });
      }
    },
    handleOddsTypeChange(value) {
      this.$store.commit('odds/SET_ODDS_TYPE', value);
      this.showOddsTypeDropdown = false;
      window.parent.postMessage(
          {
            type: 'oddsTypeChanged',
            oddsType: value
          },
          '*'
      );
    },
    handleClickOutside(event) {
      const container = this.$refs.dropdownContainer;
      if (container && !container.contains(event.target)) {
        this.showOddsTypeDropdown = false;
      }
    },
    calculateDropdownPosition() {
      const container = this.$refs.dropdownContainer;
      const dropdown = this.$refs.dropdownContent;
      if (!container || !dropdown) return;

      const containerRect = container.getBoundingClientRect();
      const dropdownRect = dropdown.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const spaceBelow = viewportHeight - containerRect.bottom;

      if (spaceBelow >= dropdownRect.height || spaceBelow > containerRect.top) {
        this.dropdownStyle = {
          top: '100%',
          right: '0',
          marginTop: '0.25rem'
        };
      } else {
        this.dropdownStyle = {
          bottom: '100%',
          right: '0',
          marginBottom: '0.25rem'
        };
      }
    }
  }
};
</script>

<style scoped>
.ih-header {
  --illinois-black-50: rgba(0, 0, 0, 0.50);
  --illinois-white-10: rgba(255, 255, 255, 0.1);
  --illinois-border: rgba(255, 255, 255, 0.1);
}

.ih-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: var(--illinois-black-50);
}

.date-container-blur {
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
}

.ih-container {
  max-width: 1200px;
  margin: 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
}

.ih-tabs-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 2.5rem;
}

.ih-tabs-container {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4rem;
}

.ih-tab-inner {
  outline: none;
  position: relative;
  height: 2.75rem;
  text-decoration: none;
  cursor: pointer;
}

@media (min-width: 768px) {
  .ih-tab-inner {
    min-height: 70px;
  }
}

.ih-tab-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.ih-tab-text {
  font-weight: bold;
  font-size: var(--font-size-3xl);
  transition: color 0.2s;
}

.ih-text-active { color: var(--text-platform); }
.ih-text-muted { color: var(--text-op-50-platform); }

.ih-indicator {
  position: absolute;
  bottom: 0;
  left: 0;
  min-height: 2px;
  background-color: var(--text-platform);
  transition: all 0.3s ease-in-out;
  will-change: transform, width;
}

.ih-settings-wrapper {
  display: flex;
  align-items: center;
  padding-right: 1rem;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 500;
}

.ih-dropdown-container { position: relative; }
.ih-settings-btn { background: transparent; border: none; outline: none; cursor: pointer; padding: 0; }

.ih-icon-box {
  height: 2.5rem;
  width: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  color: var(--text-platform);
  transition: all 0.2s;
}

.ih-icon-box:hover { background-color: var(--illinois-white-10); }

.ih-dropdown-menu {
  position: absolute;
  z-index: 50;
  width: 12rem;
  border-radius: 0.375rem;
  box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05);
  border: 1px solid var(--illinois-border);
  background-color: var(--bg-cart);
  color: var(--text-cart);
}

.ih-dropdown-padding { padding: 0.75rem; }
.ih-dropdown-title { font-size: var(--font-size-2xl); font-weight: bold; margin-bottom: 0.75rem; text-transform: uppercase; }
.ih-dropdown-options { display: flex; flex-direction: column; gap: 0.5rem; }

.ih-radio-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 0.375rem;
  transition: background-color 0.2s;
}

.ih-radio-label:hover, .ih-bg-hover { background-color: var(--bg-odd-cart); }

.ih-radio-input {
  margin-right: 0.75rem;
  width: 1rem;
  height: 1rem;
  accent-color: var(--color-accent);
  cursor: pointer;
}

.ih-radio-text { font-size: var(--font-size-4xl); }

.ih-fade-enter-active, .ih-fade-leave-active { transition: opacity 100ms ease-in; }
.ih-fade-enter, .ih-fade-leave-to { opacity: 0; }
</style>